export const SET_DEVICE = "app/deviceSelected/SET_DEVICE";
export const MERGE_DEVICE = "app/deviceSelected/MERGE_DEVICE";
export const SET_DEVICE_VIEW = "app/deviceSelected/SET_DEVICE_VIEW";
export const GET_METRICS = "app/deviceSelected/GET_METRICS";
export const GET_HELTH_METRICS = "app/deviceSelected/GET_HELTH_METRICS";
export const GET_READ_QUALITY_METRICS =
  "app/deviceSelected/GET_READ_QUALITY_METRICS";
